<ngx-datatable 
    #table 
    class='material striped' 
    [loadingIndicator]="loadingLocal"
    [columns]="columns"
    [columnMode]="'force'" 
    [headerHeight]="50"
    [footerHeight]="50" 
    [rowHeight]="'auto'"
    (sort)="onSort($event)"
    [rows]='rows'>

    <ngx-datatable-column name="Data" prop="data_operacao" [sortable]="false" [width]="80">
        <ng-template let-rowIndex="rowIndex" let-data_operacao="value" ngx-datatable-cell-template>
            {{ data_operacao | date:'dd/MM/yyyy' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Mercado" prop="mercado" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-mercado="value" ngx-datatable-cell-template>
            {{ mercado }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Descrição" prop="descricao" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-descricao="value" ngx-datatable-cell-template>
            {{ descricao }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Ativo" prop="ativo" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-ativo="value" ngx-datatable-cell-template>
            {{ ativo }}
        </ng-template>
    </ngx-datatable-column>   
    
    <ngx-datatable-column name="Lançamento" prop="tipo" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-tipo="value" ngx-datatable-cell-template>
            {{ tipo }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Captação" prop="captacao" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-captacao="value" ngx-datatable-cell-template>
            <span
            [ngClass]="{
                'negativo': captacao < 0, 
                'positivo': captacao > 0
            }"
        >
            R$ {{ captacao | number : '1.2-2' }}
        </span>
        </ng-template>
    </ngx-datatable-column>

</ngx-datatable>

<div style="padding: 5px 10px">
    <mat-paginator 
        #paginator 
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent($event)">
    </mat-paginator>
</div>